import useSWR from 'swr'
import api from '../services/api';

export function useFetch(url: string, fallbackData) {
  const { data, error, mutate } = useSWR(url, async url => {
    //
    const response = await api.get(url);

    return response.data;
  },{
      fallbackData,
  })
  //console.log("useFetch",error,mutate)

  return { data, error, mutate}
}
